import { assigneesConstants } from '../constants';
import { AssigneesResI } from '../models/Assignees';

const initialState = {
  isLoading: false,
  assignees: [] as AssigneesResI,
};
export const assignees = (
  state = initialState,
  action: {
    type: string;
    payload: { assignees?: AssigneesResI; error?: string };
  },
) => {
  switch (action.type) {
    case assigneesConstants.ASSIGNEES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case assigneesConstants.ASSIGNEES_SUCCESS:
      return {
        ...state,
        assignees: action.payload.assignees,
        isLoading: false,
      };
    case assigneesConstants.ASSIGNEES_ERROR:
      return {
        ...state,
        error: action.payload.error,
        isLoading: false,
      };
    default:
      return state;
  }
};
